import { ContractContext } from '../contexts/ContractContext';
import React, { useContext } from 'react';
import { clearSession } from '../../helpers.jsx';
import { useHistory } from 'react-router-dom';
import { useEnvironment } from '../_ReactHooks/useEnvironment.js';

export const useLogout = () => {
    const contractContext = useContext(ContractContext);
    const history = useHistory();
    const { redirectUrl, loginPath } = useEnvironment();

    const handleLogout = () => {
        let path = redirectUrl + loginPath;
        handleRoute(path);
    };

    const handleRoute = (path) => {
        if (path.includes('http')) {
            window.location.href = path;
        } else {
            history.push({ pathname: path });
        }
    };

    const logout = (isTimeoutModalActive = false) => {
        contractContext.setLoggedIn(false);
        contractContext.updateContract({});
        contractContext.updateContracts([]);
        contractContext.setCoverageDocs(null);
        contractContext.updatePlanLookup({});
        contractContext.setHandshakeSuccessful(null);
        contractContext.updateHwaToken('');
        contractContext.updateParty({});
        contractContext.updateViaClientHandshake(false);
        contractContext.setLogin(false);
        contractContext.setClientToken('');
        clearSession();
        !isTimeoutModalActive && handleLogout(); //for timeout modal handle logout from component itself
    };

    return { logout, handleLogout };
};
